import {
  Component,
  Input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { customsClearanceStatus } from "./customs-clearance-status.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface BankChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-customs-clearance-status-select",
  templateUrl: "./customs-clearance-status-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class CustomsClearanceStatusSelectComponent implements OnInit {
  public readonly statusChange = output<string>();
  @Input() public status;

  public subscription = new Subscription();
  public statusList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildBankList();
  }

  public onStatusChange(event: BankChangeEvent) {
    this.statusChange.emit(event.value);
  }

  private buildBankList() {
    this.statusList.push({
      label: "None",
      value: null,
    });
    Object.keys(customsClearanceStatus).map((key) => {
      this.statusList.push({
        label: customsClearanceStatus[key],
        value: key,
      });
    });
  }
}
